import { Box, Grid2 } from '@mui/material'
import { memo } from 'react'

import Text from '../shared/text/Text'

import FaIcon from 'src/components/shared/faIcon/FaIcon'
import { RouterLink } from '../../routes/components'
import Button from '../shared/button/Button'
import { buildHomeQuickMenu } from '../../layouts/nav-config-dashboard'
import { NAVIGATION_BLANK_PARAMS } from '../../util/navigation.helpers'
import AppWelcomeBox from './AppWelcomeBox'

const AppWelcome = ({ t, title, description, img, symbol, onOpenCOEStore }) => {
  return (
    <AppWelcomeBox>
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          alignItems: { xs: 'center', md: 'flex-start' }
        }}
      >
        <Text
          variant='h4'
          sx={{ whiteSpace: 'pre-line', mb: 1 }}
          label={title}
        />

        <Text
          variant='body2'
          sx={{ opacity: 0.64, maxWidth: 360, mb: 3 }}
          label={description}
        />
        <Grid2
          container
          columnSpacing={1}
          rowSpacing={1}
          sx={{ justifyContent: { xs: 'center' }, mb: { xs: 2 } }}
        >
          {buildHomeQuickMenu({
            t,
            symbol,
            onOpenCOEStore
          }).map(({ title, path, icon, onClickNav, external }) => {
            const linkProps = onClickNav
              ? {
                  onClick: onClickNav
                }
              : external
                ? { href: path, ...NAVIGATION_BLANK_PARAMS }
                : { component: RouterLink, to: path }
            return (
              <Grid2 size={{ xs: 'auto' }} key={title}>
                <Button
                  label={title}
                  startIcon={<FaIcon icon={icon} width={18} />}
                  color='primary'
                  size='small'
                  sx={{
                    width: 'auto',
                    maxWidth: 150,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                  {...linkProps}
                />
              </Grid2>
            )
          })}
        </Grid2>
      </Box>
      {img}
    </AppWelcomeBox>
  )
}

export default memo(AppWelcome)
